import { Grid, Row } from 'antd'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useCurrentConfig } from 'app/lib/hooks/useCurrent'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

const InfoNote: React.FC = () => {
  const { tCore } = useTranslation({ scope: 'info', recordType: RecordType.overview })
  const { md } = Grid.useBreakpoint()
  const { holidayConfig } = useCurrentConfig()
  if (!holidayConfig.showBanner()) return null

  return (
    <KCol card span={24}>
      <Row gutter={[24, 24]} className={!md && 'flex-col-reverse'}>
        <KCol xs={24} md={18}>
          <h3>{tCore({ id: 'christmas_break_title' })}</h3>
          <p style={{ whiteSpace: 'pre-line' }}>
            {tCore(
              { id: 'christmas_text' },
              {
                startDate: holidayConfig.getStartDate(),
                endDate: holidayConfig.getEndDate(),
                nexEndDate: holidayConfig.getNexEndDate()
              }
            )}
          </p>
        </KCol>
        <KCol xs={24} md={6} className={md ? 'text-right px-5' : 'text-center'}>
          <Icon type="mobile_crane_with_tree" />
        </KCol>
      </Row>
    </KCol>
  )
}

export default InfoNote
